// extracted by mini-css-extract-plugin
export default {"responsiveSection":"ResponsiveSection-module__responsiveSection___2NwFs"};